/***************************************************************
 *                                                             *
 *                           ADMIN                             *
 *                                                             *
 **************************************************************/

/**************************************
 *              MARKERS               *
 **************************************/

export const ADMIN_MARKER_CREATE = ['admin', 'markers', 'create'];
export const ADMIN_MARKER_UPDATE = ['admin', 'markers', 'update'];
export const ADMIN_MARKER_DELETE = ['admin', 'markers', 'delete'];
export const ADMIN_MARKERS_ALL = ['admin', 'markers', 'all'];

/**************************************
 *          GATHERING SPOTS           *
 **************************************/

export const ADMIN_GATHERING_SPOT_CREATE = [
  'admin',
  'gathering_spots',
  'create',
];
export const ADMIN_GATHERING_SPOT_UPDATE = [
  'admin',
  'gathering_spots',
  'update',
];
export const ADMIN_GATHERING_SPOT_DELETE = [
  'admin',
  'gathering_spots',
  'delete',
];

/**************************************
 *       GATHERING SPOT TYPES         *
 **************************************/

export const ADMIN_GATHERING_SPOT_TYPES_CREATE = [
  'admin',
  'gathering_spot_types',
  'create',
];
export const ADMIN_GATHERING_SPOT_TYPES_UPDATE = [
  'admin',
  'gathering_spot_types',
  'update',
];
export const ADMIN_GATHERING_SPOT_TYPES_DELETE = [
  'admin',
  'gathering_spot_types',
  'delete',
];

/**************************************
 *               ITEMS                *
 **************************************/

export const ADMIN_ITEM_CREATE = ['admin', 'items', 'create'];
export const ADMIN_ITEM_DELETE = ['admin', 'items', 'delete'];
export const ADMIN_ITEM_UPDATE = ['admin', 'items', 'update'];
export const ADMIN_ITEMS_ALL = ['admin', 'items', 'all'];

export const ADMIN_COLLECTIBLE_VARIANT_CREATE = [
  'admin',
  'collectible',
  'variant',
  'create',
];
export const ADMIN_COLLECTIBLE_VARIANT_DELETE = [
  'admin',
  'collectible',
  'variant',
  'delete',
];
export const ADMIN_COLLECTIBLE_VARIANT_UPDATE = [
  'admin',
  'collectible',
  'variant',
  'update',
];
export const ADMIN_COLLECTIBLE_VARIANT_ALL = [
  'admin',
  'collectible',
  'variant',
  'all',
];

/**************************************
 *               USERS                *
 **************************************/

export const ADMIN_USERS_ALL = ['admin', 'users', 'all'];
export const ADMIN_USERS_DELETE = ['admin', 'users', 'delete'];
export const ADMIN_USERS_GODMODE = ['admin', 'users', 'godmode'];
export const ADMIN_USERS_RESET = ['admin', 'users', 'reset'];

/**************************************
 *              REVIEW               *
 **************************************/

export const ADMIN_REVIEW_ALL = ['admin', 'review', 'all'];
export const ADMIN_REVIEW_DELETE = ['admin', 'review', 'delete'];

/**************************************
 *               MISC                 *
 **************************************/

export const ADMIN_ELEMENTS_ALL = ['admin', 'elements', 'all'];
export const ADMIN_SETTINGS_UPDATE = ['admin', 'settings', 'update'];

/***************************************************************
 *                                                             *
 *                           OTHER                             *
 *                                                             *
 **************************************************************/

/**************************************
 *          GATHERING SPOTS           *
 **************************************/

export const GATHERING_SPOT = ['gathering_spot'];
export const GATHERING_SPOTS_ALL = ['gathering_spots', 'all'];

/**************************************
 *       GATHERING SPOT TYPES         *
 **************************************/

export const GATHERING_SPOT_TYPE = ['gathering_spot_type'];
export const GATHERING_SPOT_TYPES_ALL = ['gathering_spot_types', 'all'];

/**************************************
 *              MARKERS               *
 **************************************/

export const MARKER = ['marker'];

/**************************************
 *               ITEMS                *
 **************************************/

export const ITEM = ['item'];
export const ITEM_TYPES_ALL = ['item_types', 'all'];

export const COLLECTIBLE_VARIANT = ['collectible', 'variant'];

/**************************************
 *             SETTINGS               *
 **************************************/

export const SETTINGS = ['settings'];
export const SETTINGS_ALL = ['settings', 'all'];

/**************************************
 *               MISC                 *
 **************************************/

export const RARITY_TYPES_ALL = ['rarity_items', 'all'];
export const USER = ['user'];
export const USERS_ALL = ['users', 'all'];
